import { useEffect, useState } from 'react';
import api from '../api/apiClient';
import Modal from '../components/Modal';
import PageHeader from '../components/PageHeader';

const emptyForm = { title: '', description: '', type: 'general', target: 'all', branch_id: '', class_grade: '' };

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    load();
  }, []);

  async function load() {
    try {
      const [historyResponse, branchResponse] = await Promise.all([
        api.get('/admin/notifications/history'),
        api.get('/admin/branches'),
      ]);
      setNotifications(historyResponse.data.data || []);
      setBranches(branchResponse.data.data || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to load notifications');
    }
  }

  const sendNotification = async (event) => {
    event.preventDefault();
    setError('');
    setSuccessMessage('');
    try {
      const response = await api.post('/admin/notifications/send', form);
      setSuccessMessage(`Notification sent to ${response.data.data.recipients} parent accounts`);
      setForm(emptyForm);
      setIsSendModalOpen(false);
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to send notification');
    }
  };

  return (
    <div>
      <PageHeader title="Notification Management" subtitle="Send alerts to all parents, branch groups, or classes" />
      {successMessage && <div className="success-message">{successMessage}</div>}
      {error && <div className="error-message">{error}</div>}

      <div className="page-header-row">
        <h3 style={{ margin: 0 }}>Notifications</h3>
        <button type="button" className="primary-button" onClick={() => setIsSendModalOpen(true)}>Send Notification</button>
      </div>

      <Modal isOpen={isSendModalOpen} onClose={() => setIsSendModalOpen(false)} title="Send Notification">
        <form className="inline-form" onSubmit={sendNotification}>
          <input placeholder="Title" value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} required />
          <select value={form.type} onChange={(e) => setForm((p) => ({ ...p, type: e.target.value }))}>
            <option value="general">general</option>
            <option value="event">event</option>
            <option value="reminder">reminder</option>
          </select>
          <select value={form.target} onChange={(e) => setForm((p) => ({ ...p, target: e.target.value }))}>
            <option value="all">All parents</option>
            <option value="branch">Specific branch</option>
            <option value="class">Specific class</option>
          </select>
          {form.target === 'branch' && (
            <select value={form.branch_id} onChange={(e) => setForm((p) => ({ ...p, branch_id: e.target.value }))} required>
              <option value="">Select branch</option>
              {branches.map((branch) => <option key={branch.id} value={branch.id}>{branch.name}</option>)}
            </select>
          )}
          {form.target === 'class' && (
            <input placeholder="Class" value={form.class_grade} onChange={(e) => setForm((p) => ({ ...p, class_grade: e.target.value }))} required />
          )}
          <textarea placeholder="Message" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} />
          <div className="modal-actions">
            <button type="button" className="secondary-button" onClick={() => setIsSendModalOpen(false)}>Cancel</button>
            <button type="submit" className="primary-button">Send</button>
          </div>
        </form>
      </Modal>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Recipient</th>
              <th>Role</th>
              <th>Type</th>
              <th>Read</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {notifications.map((item) => (
              <tr key={item.id}>
                <td>{item.title}</td>
                <td>{item.user_name || '-'}</td>
                <td>{item.role || '-'}</td>
                <td>{item.type || '-'}</td>
                <td>{item.is_read ? 'Yes' : 'No'}</td>
                <td>{item.created_at ? new Date(item.created_at).toLocaleString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
